module.exports = __webpack_public_path__ + "img/service.781d79cf.svg";